import httpService from '../_utils/http-service';
import { getAuthHttpConfig } from '../_utils/auth-utils';

import *  as types from './types';
import { traceEvent } from "../_utils/analytics-utils";

export const fetchPoints = ({ customerId }, callback) => {

    return function (dispatch, getState) {
        const storage = getState().storage;
        httpService.get(`/customers/${customerId}/balance`,
            getAuthHttpConfig(storage)).then(res => {

                if (res.data.statusCode === 200) {
                    const points = res.data.data.balance.points;

                    callback({ success: true, points });
                } else {
                    traceEvent("error", "fetchPoints");
                    callback({ success: false });
                }
            }).catch(err => {
                traceEvent("error", "fetchPoints");
                callback({ success: false })
            })
    }
}

export const fetchPointsHistory = ({ customerId }, callback) => {

    return function (dispatch, getState) {
        const storage = getState().storage;
        httpService.get(`/customers/${customerId}/points?includeHistory=true&includeEarn=true`,
            getAuthHttpConfig(storage)).then(res => {
                if (res.data.statusCode === 200) {
                    const pointsHistory = res.data.data.history;
                    const earn = res.data.data.earn;
                    const points = res.data.data.points;
                    dispatch(
                        {
                            type: types.SET_CUSTOMER_POINTS_HISTORY,
                            payload: {
                                pointsHistory,
                                earn,
                                points
                            }
                        });

                    callback({ success: true });
                } else {
                    traceEvent("error", "fetchPointsHistory");
                    callback({ success: false });
                }
            }).catch(err => {
                traceEvent("error", "fetchPointsHistory");
                callback({ success: false })
            })
    }
}
